module.exports = __webpack_public_path__ + "static/media/cg.c2f55ad5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cg.svg
// module id = 832
// module chunks = 0